module.exports = __webpack_public_path__ + "img/451028.f20d1c10.png";